"use strict";

exports.__esModule = true;
var _ModeSwitch = require("./ModeSwitch");
Object.keys(_ModeSwitch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModeSwitch[key]) return;
  exports[key] = _ModeSwitch[key];
});